// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"index__imgBox__2KvOq","imgContainer":"index__imgContainer__2Non_"};